import { render } from "./SliderPromoActivas.vue?vue&type=template&id=d7b7df2a"
import script from "./SliderPromoActivas.vue?vue&type=script&scoped=true&lang=js"
export * from "./SliderPromoActivas.vue?vue&type=script&scoped=true&lang=js"

import "./SliderPromoActivas.vue?vue&type=style&index=0&id=d7b7df2a&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__